import React, {FC, Fragment, useEffect, useMemo} from "react"
import {ProductDetail} from "./ProductDetail"
import {ProductCMS, ProductContexts, ProductMainSectionTypes} from "./models"
import {useParams} from "react-router-dom";
import {useCMSStore} from "../../store/cmsStore";
import {finalizationCallback, mzUseNavigate} from "../../utils";
import {AuthService} from "../../service/AuthService";
import {Custom} from "../Custom";
import {HttpService} from "../../service/HttpService";

export interface CollectionProductProps {
    private: boolean
}

export const CollectionProduct: FC<CollectionProductProps> = props => {
    const navigate = mzUseNavigate();
    const customProject = HttpService?.customProject;
    const {pages, setCurrentPage} = useCMSStore();
    const cmsConfig: ProductCMS = useMemo(() => pages?.productDetails as ProductCMS, [pages]);

    useEffect(() => {
        setCurrentPage(pages?.productDetails ?? undefined);

        if(cmsConfig?.section?.sections){
            finalizationCallback(cmsConfig?.section?.sections, navigate)
        }
    }, [cmsConfig?.page]);


    const {initiativeLogicId} = useParams();

    const collectionCms = useMemo(() => {

        // Search needed section
        const neededSection = cmsConfig?.section?.sections.find(el => el.type == `INITIATIVE_${initiativeLogicId}`);

        // Fallback section
        const fallBackSection = cmsConfig?.section?.sections.find(el => el.type == ProductMainSectionTypes.LOYALTY_COLLECTION)

        return neededSection ? neededSection : fallBackSection;

    }, [cmsConfig, initiativeLogicId]);

    return (
        <>
            {customProject?.customFrontend &&
            customProject?.frontendComponents?.some(component => component?.pathUrl === "/catalog/loyalty-collection-product-custom" || (component?.pathUrl === "(/public/catalog/loyalty-collection-product-custom" && !AuthService.authorized))
                ? <Custom customFrontendUrl={customProject?.customFrontendUrl}
                          type={customProject?.frontendComponents?.find(comp => comp?.pathUrl === "/public/catalog/loyalty-collection-product-custom" || (comp?.pathUrl === "/public/catalog/loyalty-collection-product-custom" && !AuthService.authorized))?.component}
                /> :
                <Fragment>
                    {
                        cmsConfig && collectionCms && collectionCms?.sections && (
                            <ProductDetail
                                context={ProductContexts.COLLECTION}
                                productsCMS={cmsConfig}
                                productSections={collectionCms?.sections}
                                private={props.private}
                                initiativeLogicId={initiativeLogicId!}
                            />
                        )
                    }
                </Fragment>}
        </>
    )
}